import { render, staticRenderFns } from "./BadgeShipmentPreparation.vue?vue&type=template&id=b577fa86&scoped=true"
import script from "./BadgeShipmentPreparation.vue?vue&type=script&lang=js"
export * from "./BadgeShipmentPreparation.vue?vue&type=script&lang=js"
import style0 from "./BadgeShipmentPreparation.vue?vue&type=style&index=0&id=b577fa86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b577fa86",
  null
  
)

export default component.exports